import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';
const ImpersonationContext = createContext(undefined);
export const useImpersonation = () => {
    const context = useContext(ImpersonationContext);
    if (!context) {
        throw new Error('useImpersonation must be used within an ImpersonationProvider');
    }
    return context;
};
export const ImpersonationProvider = ({ children }) => {
    const [isImpersonating, setIsImpersonating] = useState(false);
    const [impersonatedClinic, setImpersonatedClinic] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const { fetchClinicStatus } = useAuth();
    const startClinicOrder = (clinic, address) => {
        setImpersonatedClinic(clinic);
        setSelectedAddress(address);
        setIsImpersonating(true);
        // Store in sessionStorage so it persists across page navigation
        sessionStorage.setItem('impersonatedClinic', JSON.stringify(clinic));
        sessionStorage.setItem('selectedAddress', JSON.stringify(address));
        sessionStorage.setItem('isImpersonating', 'true');
        fetchClinicStatus();
    };
    const stopImpersonation = useCallback(() => {
        setImpersonatedClinic(null);
        setSelectedAddress(null);
        setIsImpersonating(false);
        // Clear from sessionStorage
        sessionStorage.removeItem('impersonatedClinic');
        sessionStorage.removeItem('selectedAddress');
        sessionStorage.removeItem('isImpersonating');
        fetchClinicStatus();
    }, [fetchClinicStatus]);
    // Initialize from sessionStorage on mount
    React.useEffect(() => {
        const storedImpersonation = sessionStorage.getItem('isImpersonating');
        const storedClinic = sessionStorage.getItem('impersonatedClinic');
        const storedAddress = sessionStorage.getItem('selectedAddress');
        if (storedImpersonation === 'true' && storedClinic && storedAddress) {
            try {
                setImpersonatedClinic(JSON.parse(storedClinic));
                setSelectedAddress(JSON.parse(storedAddress));
                setIsImpersonating(true);
            }
            catch (error) {
                console.error('Error parsing stored impersonation data:', error);
                stopImpersonation();
            }
        }
    }, [stopImpersonation]);
    const value = {
        isImpersonating,
        impersonatedClinic,
        selectedAddress,
        startClinicOrder,
        stopImpersonation,
    };
    return _jsx(ImpersonationContext.Provider, { value: value, children: children });
};
